<mat-dialog-content class="list-card-dialog-content">
  @if (showOwnHeader) {
    <h2>
      <strong>{{ 'Cashiers List' | translate }}</strong>
    </h2>
  }

  <div class="list-card">
    <div class="list-card__scroll">
      <div class="list-card__table">
        <div class="list-card__row list-card__row--head">
          <span class="list-card__col list-card__col--id">ID</span>
          <span class="list-card__col list-card__col--name">{{
            'Cashier' | translate
          }}</span>
          <span class="list-card__col list-card__col--user">{{
            'User' | translate
          }}</span>
          <span class="list-card__col list-card__col--action">{{
            'Options' | translate
          }}</span>
        </div>

        @if (listCashiers.length > 0) {
          @for (cashier of listCashiers; track cashier; let i = $index) {
            <div class="list-card__row">
              <span class="list-card__col list-card__col--id">{{
                cashier.id_payment
              }}</span>
              <span class="list-card__col list-card__col--name">{{
                cashier.description
              }}</span>
              <span class="list-card__col list-card__col--user">{{
                getUser(userList, cashier.id_user!)
              }}</span>
              <span class="list-card__col list-card__col--action">
                <button
                  class="list-card__delete"
                  disabled
                  (click)="remove(cashier.id_payment, i)"
                  type="button"
                  [attr.aria-label]="'Options' | translate"
                >
                  <v-one-icon name="trash" [color]="'var(--color-gray-500)'" />
                </button>
              </span>
            </div>
          }
        } @else {
          <div class="list-card__empty">
            {{ 'NO RECORDS FOUND' | translate }}
          </div>
        }

        <form [formGroup]="registerForm">
          <ng-container formArrayName="itemRows">
            @for (row of rowsArr.controls; track row; let i = $index) {
              <ng-container [formGroupName]="i">
                <div class="list-card__row list-card__row--form">
                  <span class="list-card__col list-card__col--id"></span>
                  <span class="list-card__col list-card__col--name">
                    <input
                      class="list-card__input"
                      type="text"
                      [placeholder]="'Add Cashiers' | translate"
                      formControlName="cashier"
                    />
                    @if (textValid('cashier', i)) {
                      <span class="list-card__error">{{
                        'Cashier invalid' | translate
                      }}</span>
                    }
                  </span>
                  <span class="list-card__col list-card__col--user">
                    <select class="list-card__select" formControlName="user">
                      <option selected value="">
                        {{ 'Select User' | translate }}
                      </option>
                      @for (user of userList; track user) {
                        <option [ngValue]="user">
                          {{ user.name }}
                        </option>
                      }
                    </select>
                    @if (textValid('user', i)) {
                      <span class="list-card__error">{{
                        'You must select a type' | translate
                      }}</span>
                    }
                  </span>
                  <span class="list-card__col list-card__col--action"></span>
                </div>
              </ng-container>
            }
          </ng-container>
          <div class="list-card__add-row">
            <button
              class="list-card__add-button"
              type="button"
              (click)="addRow()"
            >
              <v-one-icon name="add" [color]="'var(--color-blue-500)'" />
              {{ 'global.paymentLists.addAnother' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>

    @if (showOwnActions) {
      <div class="list-actions">
        <button
          class="list-actions__button list-actions__button--outline"
          mat-dialog-close
          type="button"
        >
          {{ 'Close' | translate }}
        </button>
        <button
          class="list-actions__button list-actions__button--primary"
          (click)="update()"
          type="button"
        >
          {{ 'Add' | translate }}
        </button>
      </div>
    } @else {
      <div class="list-actions">
        <button
          class="list-actions__button list-actions__button--save"
          [disabled]="!registerForm.dirty"
          (click)="update()"
          type="button"
        >
          {{ 'global.paymentLists.saveAndClose' | translate }}
        </button>
      </div>
    }
  </div>
</mat-dialog-content>
